
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"fill":"none","d":"M0 0h32v32H0z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M25 5.02v2.42H7V5.02H5v22h2v-2h18v2h2v-22zm0 10.21h-8v-2h8zm-10 0H7v-2h8zm0 1.95v1.95H7v-1.95zm2 0h8v1.95h-8zm8-5.84h-8v-2h8zm-10-2v2H7v-2zM7 21.07h8v1.95H7zm10 1.95v-1.95h8v1.95z"}})])
          )
        }
      }
    